import { Skeleton } from '@mui/material';
import React from 'react';

const ControlsSkeleton = () => {
    return (
        <React.Fragment>
            <Skeleton
                variant="rectangular"
                animation="wave"
                height={28}
                width={112}
                style={{ marginRight: '10px' }}
            />
            <Skeleton
                variant="rectangular"
                animation="wave"
                height={28}
                width={56}
            />
        </React.Fragment>
    );
};

export default ControlsSkeleton;
